/**
 * Created by tpetridis on 23/2/2017.
 */
export default {
  /*eslint-disable */
  // User object will let us check authentication status
  user: {
    authenticated: false,
  },
  getParameterNameByPattern(obj, pattern) {
    let key, keys = [];
    for (key in obj) {
      if (obj.hasOwnProperty(key) && pattern.test(key)) keys.push(key);
    }
    return keys;
  },
  checkAuth() {
    console.log('INSIDE AUTH auth.js /auth');
    const jwtFromLocalStorage = localStorage.getItem('jwtToken');
    const jwtFromSessionStorage = sessionStorage.getItem('jwtToken');
    if (jwtFromLocalStorage) { //case login
      console.log('Return TRUE from Login due to Local Storage');
      return true;
    } else if (jwtFromSessionStorage) {
      console.log('Return TRUE from Login due to Session Storage ');
      return true;
    } else {
      return false;
    }
  },
  getJwt() {
    // console.log('INSIDE AUTH auth.js /getJwt');
    const jwtFromLocalStorage = localStorage.getItem('jwtToken');
    const jwtFromSessionStorage = sessionStorage.getItem('jwtToken');
    if (jwtFromLocalStorage) {
      // console.log('Return TRUE from getJwt due to Local Storage GET JWT ' + jwtFromLocalStorage);
      return localStorage.getItem('jwtToken');
    } else if (jwtFromSessionStorage) {
      // console.log('Return TRUE from getJwt due to Session Storage GET JWT ' + jwtFromSessionStorage);
      return sessionStorage.getItem('jwtToken');
    }
  },
};



// WEBPACK FOOTER //
// ./src/common/auth.js